import { Input, type GetProps } from 'antd';
import cs from "classnames";
import Styles from "./Styles.module.scss";

type PasswordProps = GetProps<typeof Input.Password>;

export default function MPPassword({ className, ...props }: MPInputProps) {
    return (
        <>
            <Input.Password
                className={cs(Styles?.MPInput, className)}
                {...props}
            />
        </>
    );
}

export interface MPInputProps extends PasswordProps {

}
